import styled from 'styled-components';
import { accent0, gray0, gray6 } from '../globals/colors';
import { font } from '../globals/fonts';

var circleSize = '2em';
var lineThickness = '1px';
var gap = "".concat(1 / 4, "em");
var trackHeight = '1em';
var gapColor = gray0;
var lineColor = gray6;
var fillColor = accent0;
var lineZIndex = -1;
var fillZIndex = 1;

export var ProgressSteps_Root = styled.div.attrs(function () {return {
    'aria-label': 'progress'
  };}).withConfig({ displayName: "ProgressStepsstyles__ProgressSteps_Root", componentId: "sc-1quj14c-0" })(["position:relative;z-index:", ";ol{display:flex;padding:0;}"],

lineZIndex);







export var ProgressSteps_Circle = styled.div.withConfig({ displayName: "ProgressStepsstyles__ProgressSteps_Circle", componentId: "sc-1quj14c-1" })(["background:", ";height:", ";width:", ";position:relative;&,&::before,&::after{border-radius:50%;}&::before,&::after{content:'';display:block;position:absolute;}&::before{background:", ";width:calc(100% + (", " * 2));height:calc(100% + (", " * 2));top:-", ";left:-", ";z-index:", ";}&::after{background:", ";width:calc(100% - (", " * 2));height:calc(100% - (", " * 2));top:", ";left:", ";z-index:", ";}"],
gapColor,
circleSize,
circleSize,













lineColor,
lineThickness,
lineThickness,
lineThickness,
lineThickness,
lineZIndex,



fillColor,
gap,
gap,
gap,
gap,
fillZIndex);



/**
 * (1) fixes broken styling in IE. (TM-44)
 */
export var ProgressSteps_Track = styled.div.withConfig({ displayName: "ProgressStepsstyles__ProgressSteps_Track", componentId: "sc-1quj14c-2" })(["background:", ";position:absolute;left:0;top:calc((", " - ", ") / 2);height:", ";width:100%;&::before,&::after{content:'';display:block;position:absolute;width:100%;}&::before{background:", ";height:calc(100% + (", " * 2));top:-", ";z-index:", ";}&::after{background:", ";height:calc(100% - (", " * 2));top:", ";z-index:", ";}"],
gapColor,


circleSize, trackHeight,
trackHeight,










lineColor,
lineThickness,
lineThickness,
lineZIndex,



fillColor,
gap,
gap,
fillZIndex);



export var ProgressSteps_Label = styled.span.withConfig({ displayName: "ProgressStepsstyles__ProgressSteps_Label", componentId: "sc-1quj14c-3" })(["color:white;font-size:.9em;margin-top:1em;letter-spacing:0.03em;font-family:", ";line-height:1;"],




font.lighter);



export var ProgressSteps_Content = styled.div.withConfig({ displayName: "ProgressStepsstyles__ProgressSteps_Content", componentId: "sc-1quj14c-4" })(["display:flex;flex-direction:column;align-items:center;position:relative;"]);






export var ProgressSteps_Spacer = styled.div.withConfig({ displayName: "ProgressStepsstyles__ProgressSteps_Spacer", componentId: "sc-1quj14c-5" })(["flex-grow:1;position:relative;", "{width:100% !important;}"],



ProgressSteps_Track);




/* stylelint-disable */
/**
 * (1) fixes broken styling in IE. (TM-44)
 */
export var ProgressSteps_Segment = styled.li.withConfig({ displayName: "ProgressStepsstyles__ProgressSteps_Segment", componentId: "sc-1quj14c-6" })(["flex-grow:2;display:flex;position:relative;&:first-of-type,&:last-of-type{flex-grow:1;}&:first-of-type ", "{width:50%;right:0;left:auto;}&:last-of-type ", "{width:50%;}&[aria-current='step']{", ":last-of-type ", "::after{display:none;}&:first-of-type ", "::after{display:none;}", " ", "::after{width:50%}&:last-of-type ", " ", "::after{width:100%;}}&[aria-current='step'] ~ &{", "::after,", "::after{display:none;}}"],








ProgressSteps_Track,





ProgressSteps_Track,





ProgressSteps_Spacer, ProgressSteps_Track,



ProgressSteps_Track,



ProgressSteps_Content, ProgressSteps_Track,



ProgressSteps_Content, ProgressSteps_Track,





ProgressSteps_Circle,
ProgressSteps_Track);




/* stylelint-enable */
//# sourceMappingURL=ProgressSteps.styles.js.map